export function compareObj (obj1, obj2) {
    if (typeof obj1 !== typeof obj2) {
        return false;
    }

    if (typeof obj1 !== 'object') {
        return true;
    }

    let keys1 = Object.keys(obj1);
    let keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let i = 0; i < keys1.length; i++) {
        let key = keys1[i];
        let key2 = keys2[i];

        if (key !== key2) {
            return false;
        }

        if (typeof obj1[key] !== typeof obj2[key]) {
            return false;
        }

        if (obj1[key] !== null && typeof obj1[key] === 'object') {
            if (!compareObj(obj1[key], obj2[key])) {
                return false;
            }
        }

        else if (obj1[key] !== obj2[key]) {
            return false;
        }
    }

    return true;
}

export function deepCopy (obj) {
    if (Array.isArray(obj)) {
        return obj.map(deepCopy);
    } else if (typeof obj === 'object' && obj !== null) {
        return Object.keys(obj)
            .map(k => ({ [k]: deepCopy(obj[k]) }))
            .reduce((a, c) => Object.assign(a, c), {});
    }
    return obj;
}

export function buildLocalizedRoute (route, language) {
    if (route.path) {
        let routePath = typeof route.path === 'string' ? route.path : route.path[language];
        route.path = `/${language}/${routePath}`;
    } else {
        route.path = '/';
    }

    route.meta = route.meta || {};
    route.meta.language = language;

    if (route.name) {
        route.name += `-${language}`;
    }

    if (route.redirect) {
        route.redirect.name += `-${language}`;
    }

    if (route.children) {
        for (let childRoute of route.children) {
            buildLocalizedRoute(childRoute, language);
        }
    }
    return route;
}



// WEBPACK FOOTER //
// ./src/util.js